import { Box, CircularProgress } from "@mui/material";

interface CustomLoaderProps {
  size?: number;
  index?: string | number;
}

const CustomLoader: React.FC<CustomLoaderProps> = ({ size = 60, index }) => {
  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      key={index}
    >
      <CircularProgress color="primary" variant="indeterminate" size={size} />
    </Box>
  );
};

export default CustomLoader;
